export const SUPPLIER_ACTIVATION_CHART_HEIGHT = 320
export const SUPPLIER_ACTIVATION_DAY_POINTS = [0, 5, 7, 10, 15, 20, 30, 45, 60, 90]
export const DEFAULT_FIRST_BID_THRESHOLD_DAYS = 7
export const DEFAULT_FIRST_COMPLETED_JOB_THRESHOLD_DAYS = 30
export const COLOR_FIRST_BID = '#30A46C'
export const COLOR_FIRST_COMPLETED_JOB = '#7B61FF'
export const SUPPLIER_ACTIVATION_EARLIEST_DATE = new Date(2024, 4, 1)
export type SupplierActivationPeriod =
  | 'last30'
  | 'last90'
  | 'last6months'
  | 'last12months'
  | 'custom'
export const SUPPLIER_ACTIVATION_PERIODS: { value: SupplierActivationPeriod; label: string }[] = [
  { value: 'last30', label: 'Last 30 days' },
  { value: 'last90', label: 'Last 90 days' },
  { value: 'last6months', label: 'Last 6 months' },
  { value: 'last12months', label: 'Last 12 months' },
  { value: 'custom', label: 'Custom' },
]
export const SUPPLIER_ACTIVATION_PERIOD_LABEL = 'Drivers created during the selected period'

export const SUPPLIER_ACTIVATION_INFO = [
  'Analyses how quickly newly created drivers engage with the platform, including the share ' +
    'of each creation cohort that places a first bid and completes a first job, and how ' +
    'those shares develop over the days following account creation.',
  'The cohort includes drivers created during the selected period. At each point on the ' +
    'curves, only drivers whose accounts have existed for at least that many days are ' +
    'included. Figures are refreshed once daily, so recent activity may take up to ' +
    'approximately 24 hours to appear.',
].join('\n\n')

export const SUPPLIER_ACTIVATION_FOOTNOTES = [
  'The cohort includes drivers created during the selected period, with each ' +
    'driver counted once per chart.',
  'Figures are refreshed once daily, so recent activity may take up to ' +
    'approximately 24 hours to appear.',
]
